/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';

import { fileLimit } from '../../helpers/crosspostCheckoutConstants';
import FileItem from './FileItem';

const UploadedFileContainer = ({
  counterClass,
  containerClass,
  currentMultimediaAddOns,
  handleCaptionUpdate,
  handleFileRemoval,
  submitCaption,
}) => {
  const currentFileCount = currentMultimediaAddOns.length;
  return (
    <>
      {currentFileCount && (
        <>
          <div className={containerClass}>
            {currentMultimediaAddOns.map((addOn) => (
              <FileItem
                key={`${addOn.file_name}-${addOn.id ?? 'new'}`}
                fileName={addOn.file_name}
                thumbnailUrl={addOn.secure_url}
                caption={addOn.caption}
                mmAddOnId={addOn.id ?? -1}
                mmAddOnMediaType={addOn.media_type}
                removeFile={() => handleFileRemoval(addOn.id)}
                updateCaption={(e) => handleCaptionUpdate(e, addOn.id)}
                submitCaption={() => submitCaption(addOn.id)}
              />
            ))}
          </div>
          <div className={counterClass}>
            {currentFileCount} added, {fileLimit - currentFileCount} remaining
          </div>
        </>
      )}
    </>
  );
};

UploadedFileContainer.propTypes = {
  counterClass: PropTypes.string.isRequired,
  containerClass: PropTypes.string.isRequired,
  currentMultimediaAddOns: PropTypes.array.isRequired,
  handleFileRemoval: PropTypes.func.isRequired,
  handleCaptionUpdate: PropTypes.func.isRequired,
  submitCaption: PropTypes.func.isRequired,
};

export default UploadedFileContainer;
